import { Navigate } from "react-router-dom";

const Protectedroute = ({ children }) => {
    const isAuthenticated=localStorage.getItem("sessionid")
    console.log(isAuthenticated,"isAuthenticated")
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default Protectedroute;